import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.jsx';
import './index.css';

const GO_FUNNEL_HOST = 'go.prosperityleaders.net';
const STUDENT_HOST = 'student.prosperityleaders.net';

/** Map go.prosperityleaders.net/{slug} URLs to /go/:slug for React Router.
 *  Leave /preapp/... alone — those are first-class public routes. */
function normalizeGoSubdomainPath() {
  if (typeof window === 'undefined') return;

  const { hostname, pathname, search, hash } = window.location;
  if (hostname !== GO_FUNNEL_HOST) return;
  if (!pathname || pathname === '/' || pathname.startsWith('/go/')) return;
  if (pathname.startsWith('/preapp/')) return;
  if (pathname.startsWith('/book/')) return;
  if (pathname.startsWith('/assets/')) return;

  window.history.replaceState(null, '', `/go${pathname}${search}${hash}`);
}

/** Map student.prosperityleaders.net/{path} to /student/{path}. */
function normalizeStudentHostPath() {
  if (typeof window === 'undefined') return;

  const { hostname, pathname, search, hash } = window.location;
  if (hostname.toLowerCase() !== STUDENT_HOST) return;
  if (pathname.startsWith('/student')) return;
  if (pathname.startsWith('/assets/')) return;

  const nextPath = pathname === '/' ? '/student' : `/student${pathname}`;
  window.history.replaceState(null, '', `${nextPath}${search}${hash}`);
}

normalizeGoSubdomainPath();
normalizeStudentHostPath();

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>
);
